import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { OutreachHomeScreen } from './OutreachHomeScreen';

/** The Outreach → Pitch route `/outreach` (design outreach a1). Every call is artist-scoped. */
const OutreachHomeViewComponent: React.FC = () => {
  const accountId = useAccountId();
  if (accountId === null) {
    return <LoadingView />;
  }
  return <OutreachHomeScreen accountId={accountId} />;
};

export const OutreachHomeView = TypedMemo(OutreachHomeViewComponent);
